import axios from "axios"

export default {
  state: () => ({
    current: {},
    recents: [],
    projectsLists: false,
    project: false,
    rolesLists: false,
    group: false
  }),
  getters: {
    getCurrent: (state) => state.current,
    getRecents: (state) => state.recents,
    projects_lists: function (state) {
      return state.projectsLists
    },
    project: function (state) {
      return state.project
    },
    group: function (state) {
      return state.group
    },
    rolesLists: function (state) {
      return state.rolesLists
    },
  },
  mutations: {
    setCurrentProject(state, currentProject) {
      state.current = currentProject
    },
    SET_PROJECTS_lISTS: function (state, projects_lists) {
      state.projectsLists = projects_lists
    },
    SET_PROJET: function (state, project) {
      state.project = project
    },
    SET_GROUP: function (state, group) {
      state.group = group
    },
    SET_ROLES_LISTS: function (state, rolesLists) {
      state.rolesLists = rolesLists
    },
    setRecentProjects(state, recentProjects) {
      state.recents = recentProjects
    },
  },
  actions: {
    /** Fetch the current project, to use between show, edit and setting views */
    async fetchCurrentProject({ commit }, idProject) {
      const data = (await axios.get(`projects/${idProject}`)).data;
      const project = {
        ...data,
        hasAccessPeriod: !!data.start_date,
        startDate: new Date(data.start_date),
        endDate: new Date(data.end_date),
      }
      commit("setCurrentProject", project)
    },
    async update_group ({commit}, {group_update, group_id}) {
      return axios.put(`groups/${group_id}`, group_update).then((r) => {
      })
        .catch((e) => {
          return e
        })
    },
    async get_roles ({ commit }) {
      return await axios.get(`roles`).then((roles) => {
        return roles.data
      })
    },
    async get_group ({ commit }, id_group) {
      return await axios.get(`groups/${id_group}`).then((group) => {
        return group.data
        commit('SET_GROUP', group.data)
      })
    },
    async delete_group ({ commit }, id_group) {
      return await axios.delete(`groups/${id_group}`).then((response) => {
        return response
      })
    },
    async createGroup({commit}, payload) {
      axios.post(`groups`,payload).then((res) => {
        console.log(res)
      })
        .catch((e) => {
          console.log(e)
        })
    },
    async delete_members_from_groups ({ commit, dispatch }, {
      group_id,
      user_id,
      project_id
    }) {
      await axios.delete(`groups/${group_id}/members/${user_id}`).then(() => {
        dispatch('get_project', project_id)
        dispatch('get_group', group_id)
      })
    },
    async get_project ({ commit }, project_id) {
      return await axios.get(`projects/${project_id}`).then((projects) => {
        return projects.data
      }).catch((e) => {
        console.log(e)
      })
    },
    /** Fetch the 4 most recent projects, showed in navbar */
    async fetchRecents({ commit }) {
      const projects = (await axios.get("me/recent_projects")).data
      commit("setRecentProjects", projects)
    },
  },
}
